module.exports = __webpack_public_path__ + "img/logo_dark.bcd8dd9e.svg";